import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import type { AppLocale } from '@dsv/shared';
import { currentLocale, setLocale } from '@/i18n';

const SIDEBAR_KEY = 'dsv.sidebarCollapsed';

export const useAppStore = defineStore('app', () => {
  const preferredCollapsed = ref(localStorage.getItem(SIDEBAR_KEY) === '1');
  const editingCollapsed = ref<boolean | null>(null);
  const sidebarCollapsed = computed(() => editingCollapsed.value ?? preferredCollapsed.value);
  const locale = ref<AppLocale>(currentLocale());
  const sheetHeading = ref<{ id: string; styleCd: string; styleNm: string | null; batch: string } | null>(null);
  function setSheetHeading(value: typeof sheetHeading.value) { sheetHeading.value = value; }
  function clearSheetHeading(id: string) { if (sheetHeading.value?.id === id) sheetHeading.value = null; }

  function toggleSidebar(): void {
    if (editingCollapsed.value !== null) editingCollapsed.value = !sidebarCollapsed.value;
    else {
      preferredCollapsed.value = !sidebarCollapsed.value;
      localStorage.setItem(SIDEBAR_KEY, preferredCollapsed.value ? '1' : '0');
    }
  }

  function enterSheet() { editingCollapsed.value = true; }
  function leaveSheet() { editingCollapsed.value = null; }

  function changeLocale(next: AppLocale): void {
    locale.value = next;
    setLocale(next);
  }

  return { sidebarCollapsed, locale, toggleSidebar, enterSheet, leaveSheet, changeLocale, sheetHeading, setSheetHeading, clearSheetHeading };
});
